module.exports = __webpack_public_path__ + "static/media/cevalogistics.8a21bf30.png";